import { h, resolveComponent } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import authMiddleware from '@/router/middleware/authMiddleware.js'
import langMiddleware from '@/router/middleware/langMiddleware'
import AppRoutes from '@/router/routes'

// Routes
const routes = [
  {
    path     : '/:locale',
    props    : true,
    component: {
      render () {
        return h(resolveComponent('router-view'))
      }
    },
    children: AppRoutes.LangRoutes
  },

  ...AppRoutes.GlobalRoutes,

  {
    name    : 'Default',
    path    : '/:pathMatch(.*)*',
    redirect: '/home'
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return savedPosition ?? { top: 0 }
  }
})

// Navigation guards
router.beforeEach(async (to, from, next) => {
  await langMiddleware(to, from, next)
})
router.beforeEach(async (to, from, next) => {
  await authMiddleware(to, from, next)
})

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload')
})

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (localStorage.getItem('vuetify:dynamic-reload')) {
      console.error('Dynamic import error, reloading page did not fix it', err)
    } else {
      console.log('Reloading page to fix dynamic import error')

      localStorage.setItem('vuetify:dynamic-reload', 'true')
      location.assign(to.fullPath)
    }
  } else {
    console.error(err)
  }
})

export default router
